var map = {
	"./Layer_1.svg": "cfcc",
	"./Layer_2.svg": "626f",
	"./Layer_3.svg": "bfbc",
	"./Layer_4.svg": "b594",
	"./Layer_5.svg": "c617",
	"./Layer_6.svg": "27ce",
	"./arena.svg": "1a78",
	"./ben-exchange.svg": "5c3e",
	"./ben-hat.svg": "29a4",
	"./bg-benefits.jpg": "f3a7",
	"./bg-gifts.jpg": "f16b",
	"./gift-blanket.svg": "e47f",
	"./gift-cooler.svg": "1d07",
	"./gift-hat.svg": "0168",
	"./gift-laptop.svg": "b4ec",
	"./gift-lunch.svg": "53d5",
	"./gift-mittens.svg": "65fe",
	"./icon-check.svg": "4d65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "639e";